module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point2_4-d408c3a36dd17a92718ca0813a75890b.jpg";